import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"height":"90vh"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "mc innerEditAppointmentContent ofs",
  style: {"margin-top":"10px","height":"90vh"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "fs20 ls1 mc centered fw600" }, "調整カレンダー一覧", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AstagSearchBox = _resolveComponent("AstagSearchBox")!
  const _component_AstagLists = _resolveComponent("AstagLists")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "SelectAstagsModal",
    "content-class": "rad10 pad15 with_white_bg ofs shadowContent modalWide noscroll",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          class: "dismiss posAb fr",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissModal && _ctx.dismissModal(...args))),
          style: {"right":"20px"}
        }, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
            width: "50",
            height: "50"
          }, null, 8, _hoisted_2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          (_ctx.rm.astagsTab?.tab_name != `default`)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fs12 mt2 fl pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeCategoryTab(`default`)))
              }, " 自分の作成したカレンダー "))
            : _createCommentVNode("", true),
          _createVNode(_component_AstagSearchBox, {
            class: "fr mr20",
            style: {"height":"40px"},
            canSelectShared: false
          }),
          _hoisted_7,
          (_ctx.astags)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_AstagLists, {
                  hideSharedAstags: true,
                  selectedCategoryTabName: _ctx.rm.astagsTab?.tab_name || `default`,
                  astags: _ctx.astags,
                  onSelectEnd: _ctx.selectEnd
                }, null, 8, ["selectedCategoryTabName", "astags", "onSelectEnd"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_9,
          _hoisted_10,
          _hoisted_11
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}